<template>
    <div class="documentation ">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb :title="$t('invite_provider')" :breadcumb-data="breadcumbData"></Breadcumb>
            </div>
        </div>
        <b-card class="cardcontainer">
            <b-form @submit="addUser">
                <b-form-group :label="$t('name')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('name')" v-model="lastname" :state="errors['lastname'] ? 'invalid': ''"/>
                    <div v-if="errors['lastname']" class="invalid-tooltip">{{ errors['lastname'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('firstname')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('firstname')" v-model="firstname" :state="errors['firstname'] ? 'invalid': ''"/>
                    <div v-if="errors['firstname']" class="invalid-tooltip">{{ errors['firstname'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('email')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" :placeholder="$t('email')" v-model="email" :state="errors['email'] ? 'invalid': ''"/>
                    <div v-if="errors['email']" class="invalid-tooltip">{{ errors['email'][0] }}</div>
                </b-form-group>
                <b-form-group :label="$t('user_type')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-select plain v-model="user_type_id" :options="userTypeData"/>
                    <div v-if="errors['user_type_id']" class="invalid-tooltip">{{ errors['user_type_id'][0] }}</div>
                </b-form-group>
                <b-form-row>
                    <div class="col-md-10 ml-md-auto">
                        <b-btn type="submit" variant="primary">{{ $t('invite_provider' )}}</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card>
    </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
    import { ADMIN_GET_USERTYPES_REQUEST } from '../_store/administration/user/actiontypes'
    import {GET_COMPANIES_REQUEST, GET_HIERARCHICAL_COMPANIES_REQUEST} from '../_store/company/actiontypes';
    import {INVITE_USER_REQUEST, USER_REQUEST} from '../_store/user/actiontypes';
    import Breadcumb from '../components/breadcumb';
    import { mapState } from 'vuex';
    import VJstree from 'vue-jstree';

    function getChildrens(company) {
        return company.companies.map(children => {
            if (children.companies.length > 0){
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': false,
                    'children': getChildrens(children),
                    'opened': false,
                }
            }
            else {
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': false,
                    'children': [],
                    'opened': false,
                }
            }
        })
    }

    export default {
        name: 'adminCategoryAdd',
        components: { Breadcumb, VJstree },
        mounted() {
            this.breadcumbData = [
                { text: this.$t('welcome'), href: '/dashboard/' },
                { text: this.$t('list_provider'), href: '/users/provider/' },
                { text: this.$t('invite_provider'), active: true }
            ];
            this.$store.dispatch(USER_REQUEST)
                .then(response => {
                    let user = response.data.user;
                    this.$store.dispatch(ADMIN_GET_USERTYPES_REQUEST)
                        .then(response => {
                            let userTypes = response.data.usertypes.map(userType => {
                                if (user.userprofile.user_type.position < userType.position && userType.position === 5){
                                    if (this.$cookie.get('language') === 'fr') {
                                        return {
                                            value: userType.id,
                                            text: userType.label
                                        };
                                    }
                                    else{
                                        return {
                                            value: userType.id,
                                            text: userType.label_en
                                        };
                                    }
                                }
                            });
                            this.userTypeData = userTypes.filter(userType => {
                                return userType !== null && userType !== undefined;
                            })
                        });
                })
        },
        computed: mapState(
            { errors: state => state.admin_user.errors,
                user: state => state.user.user
            }),
        data() {
            return ({
                breadcumbData: [],
                userTypeData: [],
                user_type_id: 0,
                company_id: 0,
                email: '',
                lastname: '',
                firstname: '',
                treeData: []
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            addUser: function (e) {
                e.preventDefault();
                this.$store.dispatch(INVITE_USER_REQUEST, {
                    lastname: this.lastname,
                    firstname: this.firstname,
                    email: this.email,
                    user_type_id: this.user_type_id
                })
                    .then((response) => {
                        console.log(response);
                        this.$router.push('/users/providers/profile/' + response.data.user.id);
                    })
                    .catch((error) => {
                        console.log('error is ==');
                        console.log(error);
                    });
            }
        }
    };
</script>
